import { Box, Progress, Select, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { quizzesIsLoading, resetHeader, searchAutocompleteList, searchReset, setAutocompleteVisibility, setHeaderAdvancedSearchParams, setHeaderText, setSelectedMenuItem } from "../../redux/actions/action";
import { loadQuizzes } from "../../redux/api/apiCalls";
import FilterTags from "../common/FilterTags";
import AllQuizzes from "./AllQuizzes";

export default function Quizzes() {
    const [selected, setSelected] = useState(0)
    const filterTexts = ["Upcoming", "Completed", "Scored Above Average", "Scored Min. Marks"]
    const { quizzesData, isLoading: quizzesAreLoading /*, quizzesError */ } = useSelector(state => state.quizzesState)
    const [visibleData, setVisibleData] = useState([])
    const finalSearch = useSelector(state => state.searchState.finalSearch)
    const advancedSearch = useSelector(state => state.advancedSearchState)
    const dispatch = useDispatch()

    const clickHandler = (id) => {
        setSelected(id)
    }

    const selectClickHandler = (e) => {
        setSelected(filterTexts.indexOf(e.target.value))
    }

    useEffect(() => {
        dispatch(setHeaderText('Quizzes'))
        dispatch(setSelectedMenuItem(2))
        dispatch(quizzesIsLoading())
        dispatch(loadQuizzes())
        dispatch(setHeaderAdvancedSearchParams(["Keywords", "Number of Questions"]))
        return () => {
            dispatch(searchReset())
            dispatch(resetHeader())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setVisibleData(quizzesData.map(filter => filter.map(course => course)))
        let autocompleteList = []
        quizzesData.forEach(filter => filter.forEach(quiz => {
            if (!autocompleteList.includes(quiz.title)) {
                autocompleteList.push(quiz.title)
            }
        }))
        autocompleteList.sort((a, b) => a - b)
        dispatch(searchAutocompleteList(autocompleteList))
        // eslint-disable-next-line
    }, [quizzesData])

    useEffect(() => {
        if (finalSearch && finalSearch.length) {
            setVisibleData(quizzesData.map(filter => filter.filter(quiz => finalSearch.includes(quiz.title))))
        }
        // eslint-disable-next-line
    }, [finalSearch])

    useEffect(() => {
        if (advancedSearch.length) {
            let filteredResult = []
            advancedSearch.forEach(param => {
                if (param[1].length > 0) {
                    if (param[0] === "Keywords") {
                        let searchKeywords = param[1].split(',')
                        searchKeywords = searchKeywords.map(word => word.toLowerCase())
                        quizzesData.forEach(filter => {
                            let filterBucket = []
                            filter.forEach(quiz => {
                                let quizKeywords = quiz.keywords.split(',')
                                for (let keyword of quizKeywords) {
                                    if (searchKeywords.includes(keyword.toLowerCase())) {
                                        filterBucket.push(quiz)
                                        break;
                                    }
                                }
                            })
                            filteredResult.push(filterBucket)
                        })
                    }
                    else {
                        if (filteredResult.length) {
                            filteredResult = filteredResult.map(filter => filter.filter(quiz => quiz.question_count.toString() === param[1].toString()))
                        }
                        else {
                            filteredResult = quizzesData.map(filter => filter.filter(quiz => quiz.question_count.toString() === param[1].toString()))
                        }
                    }
                }
            })
            if (filteredResult.length) {
                setVisibleData(filteredResult)
            }
        }
        // eslint-disable-next-line
    }, [advancedSearch])


    return (
        <Box
            px='1rem'
            w='95%'
            minH='90vh'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            <Text
                fontSize={['20px', '25px', '30px', '40px']}
                d={['none', 'none', 'none', 'none', 'flex']}
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                pt='2rem'
            >
                Quizzes
            </Text>
            {
                quizzesAreLoading && quizzesData.length === 0 ? <Progress isIndeterminate size='xs' width='100%' /> :
                    <>
                        <Box d={['none', 'none', 'none', 'none', 'flex']} mt='2' mb='2rem'>
                            {filterTexts.map((filter, idx) => <FilterTags
                                id={idx}
                                key={idx}
                                text={filter}
                                count={visibleData[idx]?.length}
                                method={clickHandler}
                                selected={selected === idx}
                            />)
                            }
                        </Box>
                        <Box
                            d={['flex', 'flex', 'flex', 'flex', 'none']}
                            width='100%'
                            justifyContent='flex-end'
                            pr='1rem'
                            mt={['2rem', '2rem', '2rem', '2']} mb='2rem'
                        >
                            <Select
                                borderRadius='lg'
                                onChange={selectClickHandler}
                                width='fit-content'
                            >
                                {filterTexts.map((filter, idx) => <option key={idx} value={filter}>{filter}</option>)}
                            </Select>
                        </Box>
                        <AllQuizzes quizzes={visibleData[selected] || []} filter={filterTexts[selected]} />
                    </>
            }
            {/* {
                !quizzesAreLoading && quizzesError && <Box>{quizzesError}</Box>
            } */}
        </Box>
    )
}